export default __webpack_public_path__ + "static/media/lapak1_barva-min.a1a797f7.png";